import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingCTA from "./components/FloatingCTA";

// Route-based code splitting for improved performance and smaller initial JS bundle
const Home = lazy(() => import("./pages/Home"));
const Courses = lazy(() => import("./pages/Courses"));
const Companies = lazy(() => import("./pages/Companies"));
const About = lazy(() => import("./pages/About"));
const Recommendations = lazy(() => import("./pages/Recommendations"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Contact = lazy(() => import("./pages/Contact"));
const UpcomingCourses = lazy(() => import("./pages/UpcomingCourses"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Forbidden = lazy(() => import("./pages/Forbidden"));

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-white text-maersk-dark antialiased selection:bg-brand-orange/20 selection:text-brand-orange">
        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Suspense fallback={<div className="min-h-[60vh]" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/kurser" element={<Courses />} />
              <Route path="/kurser/kommende-hold" element={<Navigate to="/kommende-hold" replace />} />
              <Route path="/kommende-hold" element={<UpcomingCourses />} />
              <Route path="/virksomheder" element={<Companies />} />
              <Route path="/om-hende" element={<About />} />
              <Route path="/anbefalinger" element={<Recommendations />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/403" element={<Forbidden />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>

        {/* Footer Section */}
        <Footer />

        {/* Floating CTA Buttons */}
        <FloatingCTA />
      </div>
    </>
  );
}

export default App;
